import { render, staticRenderFns } from "./SourcingSupplierTable.vue?vue&type=template&id=06e259e3&scoped=true"
import script from "./SourcingSupplierTable.vue?vue&type=script&lang=js"
export * from "./SourcingSupplierTable.vue?vue&type=script&lang=js"
import style0 from "./SourcingSupplierTable.vue?vue&type=style&index=0&id=06e259e3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e259e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06e259e3')) {
      api.createRecord('06e259e3', component.options)
    } else {
      api.reload('06e259e3', component.options)
    }
    module.hot.accept("./SourcingSupplierTable.vue?vue&type=template&id=06e259e3&scoped=true", function () {
      api.rerender('06e259e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sourcing/SourcingSupplierTable.vue"
export default component.exports